import Vue from 'vue'
import VueRouter from 'vue-router'
import './config/icons'
import 'moment-timezone'
import './config/calendar'
import './assets/css/tailwind.css'
import './assets/css/public-pages.css'
import './sass/public-app.scss'
import store from './store'
import filters from './config/filters'
import PublicApp from './PublicApp.vue'
import { publicRoutes } from './router/public'
import Notifier from 'App/Alerts/Notifier'
import Dispatcher from 'App/Events/Dispatcher'

Object.entries(filters).forEach(([name, filter]) => {
	Vue.filter(name, filter)
})

Vue.prototype.$alert = new Notifier(new Dispatcher())

Vue.config.productionTip = false

Vue.use(VueRouter)

new Vue({
	router: new VueRouter({
		mode: 'history',
		routes: publicRoutes,
	}),
	store,
	render: h => h(PublicApp),
}).$mount('#app')
